import React, { useEffect, useRef, useState } from 'react';
import '../../styles/AllBoatsSection.css';

const SIZE_RANGES = [
  { label: '21ft - 40ft', range: '21-40' },
  { label: '41ft - 60ft', range: '41-60' },
  { label: '61ft - 79ft', range: '61-79' },
  { label: '80ft and up', range: '80+' },
];

const BoatSizeFilterModal = ({ onClose, onApply, selected, anchorRef }) => {
  // selected puede ser string (ej: '61-79') o un objeto {label, range}
  const [selectedRange, setSelectedRange] = useState(selected);
  const panelRef = useRef(null);

  useEffect(() => {
    setSelectedRange(selected);
  }, [selected]);

  // Cerrar al hacer click fuera
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        panelRef.current &&
        !panelRef.current.contains(event.target) &&
        (!anchorRef || !anchorRef.current || !anchorRef.current.contains(event.target))
      ) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose, anchorRef]);

  // Al seleccionar, aplicar y cerrar
  const handleSelect = (range) => {
    setSelectedRange(range);
    onApply(range);
    onClose();
  };

  // Clear size filter
  const handleClearSize = () => {
    setSelectedRange(null);
    onApply(null);
    onClose();
  };

  return (
    <div className="boat-size-filter-dropdown-panel" ref={panelRef}>
      <div className="boat-size-filter-list">
        {/* Clear size filter option */}
        <button
          className={
            'boat-size-filter-btn' +
            (!selectedRange ? ' boat-size-filter-btn--active' : '')
          }
          onClick={handleClearSize}
          type="button"
        >
          All Sizes
        </button>
        
        {/* Size range options */}
        {SIZE_RANGES.map(range => (
          <button
            key={range.label}
            className={
              'boat-size-filter-btn' +
              ((selectedRange === range.range || (selectedRange && selectedRange.range === range.range))
                ? ' boat-size-filter-btn--active'
                : '')
            }
            onClick={() => handleSelect(range)}
            type="button"
          >
            {range.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BoatSizeFilterModal; 